import { gql } from "@apollo/client";

import { userFragment } from "src/graphql/anti-fraud/fragments/UserFragment";

export const adminStatusFragment = gql`
  fragment AdminStatus on AdminStatus {
    creation
    lastModification
    author {
      ...UserFragment
    }
    lastModifier {
      ...UserFragment
    }
  }

  ${userFragment}
`;
